export default "__VITE_ASSET__BrBnad3c__"